import React, { useState } from 'react';
import Papa from 'papaparse';
import axios from 'axios';
import GLOBALVAR from '../constants';

const ImportLoanPayments = () => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleImport = () => {
    if (!file) {
      alert('Please select a file first!');
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const data = results.data;

        for (let row of data) {
          try {
            // Check if the loan processing entry exists
            const loanProcessingResponse = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/payments/check`, {
              params: {
                dateGranted: row['Loan Date'],
                amountGranted: parseFloat(row['Loan Amount']),
                loanTerm: parseInt(row['Payment Terms'])
              }
            });

            if (loanProcessingResponse.data.exists) {
              const loanProcessingID = loanProcessingResponse.data.id;

              // Prepare the payment payload
              const paidPenalty = parseFloat(row['Penalty']) || 0;
              const paymentAmount = parseFloat(row['Payment Amount']) + paidPenalty;
              const paidInterest = paymentAmount * 0.05;
              const paidPrincipal = paymentAmount - paidInterest;

              const paymentPayload = {
                loanProcessingID: loanProcessingID,
                paymentDate: row['Payment Date'],
                prNumber: '',
                orNumber: '',
                paymentType: 'cash',
                chequeNumber: '',
                paidInterest: paidInterest,
                paidPrincipal: paidPrincipal,
                paidPenalty: paidPenalty,
                paidOther: 0,
                paidTotal: paymentAmount
              };

              // Add the payment entry
              const paymentResponse = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/payments/add`, paymentPayload);
              console.log('Payment entry added successfully!', paymentResponse.data);
            } else {
              console.warn(`Loan processing entry not found for Loan Date: ${row['Loan Date']}, Loan Amount: ${row['Loan Amount']}, Payment Terms: ${row['Payment Terms']}`);
            }
          } catch (error) {
            console.error('Error processing payment entry:', error);
          }
        }

        alert('CSV import complete!');
      }
    });
  };

  return (
    <div>
      <h1>CSV Import</h1>
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <button onClick={handleImport}>Import CSV</button>
    </div>
  );
};

export default ImportLoanPayments;
